import { NextBackgroundImage } from 'components/NextImage';

import styles from './ItemModalInfo.module.scss';

export type ItemModalInfoProps = {
  image: string;
  title: string;
  owner: string;
  ownerTitle: string;
};

export const ItemModalInfo = ({ image, title, owner, ownerTitle }: ItemModalInfoProps) => {
  return (
    <div className={styles.itemModalInfo}>
      <NextBackgroundImage customClass={styles.itemModalIcon} src={image} alt={title} />
      <div className={styles.itemModalBody}>
        <h4>{title}</h4>
        <p>
          {`${ownerTitle} `}
          <span>{owner}</span>
        </p>
      </div>
    </div>
  );
};
